import { render, staticRenderFns } from "./app.mpx?vue&type=template&id=45860dfb&app=true"
import script from "./app.mpx?vue&type=script&lang=js&app=true"
export * from "./app.mpx?vue&type=script&lang=js&app=true"
import style0 from "./app.mpx?vue&type=style&index=0&mpxStyleOptions=%7B%22mid%22%3A%22mpx-app-scope%22%7D&lang=css&app=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports